/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DynamicBrandingService } from '@boxx/dynamic-branding';
import { Chart, registerables } from 'chart.js';
import { takeUntil } from 'rxjs/operators';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-contact-chart-widget',
  templateUrl: './contact-chart-widget.component.html',
  styleUrls: ['./contact-chart-widget.component.scss'],
})
export class ContactChartWidgetComponent implements OnInit {
  @ViewChild('contactChart', { static: false }) contactChart;

  @Input() set stats(payload: IStatsProps) {
    this.myStats = payload;

    if (payload.total) {
      this.setChartTheme();
      this.createChart([this.stats.client, this.stats.prospect, this.stats.not_specified]);
    }
  }

  get stats(): IStatsProps {
    return this.myStats;
  }

  chart: Chart | any;
  chartData: any = {
    responsive: false,
    datasets: [
      {
        // set values in order for: [prospect, client, not_specified]:
        data: [],
        backgroundColor: [],
      },
    ],
  };

  private myStats: IStatsProps = {
    total: 0,
    client: 0,
    prospect: 0,
    not_specified: 0,
  };

  constructor(dBrandingService: DynamicBrandingService) {
    Chart.register(...registerables);

    dBrandingService.themeChange$.subscribe(() => {
      if (this.chart) {
        this.setChartTheme();
        this.createChart([this.myStats.client, this.myStats.prospect, this.myStats.not_specified]);
      }
    });
  }

  ngOnInit() {
    setTimeout(() => {
      try {
        this.chart = new Chart(this.contactChart.nativeElement, {
          type: 'doughnut',
          data: this.chartData,
          options: {
            cutout: 50,
          },
        });

        // set values in order for: [client, prospect, not_specified]
        this.createChart([this.stats.client, this.stats.prospect, this.stats.not_specified]);
      } catch (e) {
        console.error('-- ngOnInit chart.js error', e);
      }
    }, 800);
  }

  getPercent(num: number){
    if(num === 1){
      return (this.stats.not_specified/this.stats.total*100).toFixed();
    }
    else if(num === 2){
      return (this.stats.prospect/this.stats.total*100).toFixed();
    }
    else if(num === 3){
      return (this.stats.client/this.stats.total*100).toFixed();
    }
    return null;
  }

  private setChartTheme() {
    const secondaryColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--ion-color-contact-chart-not-specified')
      .trim();
    const tertiaryColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--ion-color-contact-chart-prospect-color')
      .trim();
    const mediumColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--ion-color-contact-chart-client-color')
      .trim();

    this.chartData.datasets[0].backgroundColor = [mediumColor, tertiaryColor, secondaryColor];
  }

  private createChart(values: Array<number>) {
    try {
      if(this.chart.data){
        this.chart.data.datasets.forEach(dataset => {
          // set values in order for: [client, prospect, not_specified]
          dataset.data = values;
        });
  
        this.chart.update();
      }
    } catch (e) {
      //console.error('-- createChart error', e);
    }
  }
}

interface IStatsProps {
  total: number;
  client: number;
  prospect: number;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  not_specified: number;
}
